import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-textile-model-category4-lang',
  templateUrl: './textile-model-category4-lang.component.html',
  styleUrls: ['./textile-model-category4-lang.component.css']
})
export class TextileModelCategory4LangComponent implements OnInit {
    textileModelCategory4Keyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.textileModelCategory4Keyno = this.stateService.getStateParams()['textilemodelcategory4_keyno'];
    }

    private async loadLanguages() {
        if (!!this.textileModelCategory4Keyno) {
            this.inputListLanguages = await this.datatask.Post(2683, { textilemodelcategory4_keyno: this.textileModelCategory4Keyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2684, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    textilemodelcategory4_keyno: number;
    textilemodelcategory4lang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory4Lang', {
//        templateUrl: 'views/components/views/textileModelCategory4Lang/textileModelCategory4Lang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'textileModelCategory4LangService', function ($stateParams, stateService, textileModelCategory4LangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let textileModelCategory4Keyno = $stateParams.textilemodelcategory4_keyno;

//            vm.model = {
//                inputListLanguages: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory4Languages() {
//                vm.model.inputListLanguages = await textileModelCategory4LangService.listTextileModelCategory4Languages({ textilemodelcategory4_keyno: textileModelCategory4Keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                textileModelCategory4LangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory4Languages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
